import { ApiSeo } from 'idt-ecommerce-api/_api/api-web/api-seo/api-seo.models';
import { Seo } from 'idt-ecommerce-api/seo/seo.models';


export class SeoModelsTransformer {

  /* Objeto hardcodeado en la librería de sistemas: corefront */
  private static readonly iSeoTemplateMap = {
    ItxRobotsPage: '/robots.txt',
    ItxWishlistPage: '/{storeId}/[{langId}/]wishlist/{sharedToken}',
    ItxPaperPage: '/{storeId}[/{langId}][/{catalogId}]/paper/{blogPath}',
    ItxProductUnifiedPage: '/{storeId}/[{langId}/]{keyWordCatentry}-l{mfname}',
    ItxCategoryUnifiedPage: '/{storeId}/[{langId}/]{keyWordCatentry}-n{seoId}',
    ItxWorldWidePage: '/[{useCookie}[/]]',
    ItxNewSearchPage: '/{storeId}[/{langId}][/{catalogId}]/q[/{searchTerm}]',
    ItxHomePage: '/{storeId}[[/{langId}][/[{catalogId}[/]]]]',
    ItxShareProxyPage: '/share/[[{keyWord}-]c{categoryId}[p{productId}][-{catalogId}].html][{*}.html]',
    ItxProductPage: '/{storeId}/[{langId}/][{keyWord}-]c{categoryId}p{productId}[c{initColor}][-{catalogId}].html',
    ItxCategoryPage: '/{storeId}/[{langId}/][{keyWord}-]c{categoryId}[-{catalogId}].html',
    ItxBlogPage: '/{storeId}[/{langId}][/{catalogId}]/blog/{blogPath}',
    ItxStorePage: '/{storeId}/[{langId}/]store-locator/[{city}/][{street}-]s{stlocId}.html',
    ItxCityStoresPage: '/{storeId}/[{langId}/]store-locator/{city}.html',
    ItxMSpotPage: '/{storeId}/[{langId}/][{catalogId}/]page/{mspotname}.html',
    '*': '/[{storeId}/[{langId}/[{catalogId}/]]]{*}.html',
    '/': '/{storeId}/[{langId}/]{pageId}.html'
  };

  /* Objeto hardcodeado en la librería de sistemas: corefront */
  private static readonly iSeoParamRegexMap = {
    sharedToken: '(.+)',
    useCookie: '(inditex|inditex-sel)',
    productId: '([0-9]+)',
    initColor: '([0-9]{3})',
    city: '(.*)',
    blogPath: '(.*)',
    storeId: '([0-9]{8,}|[a-zA-Z]{2}|[a-zA-Z]{2}nv)',
    keyWord: '(.*)',
    catalogId: '([0-9]{8,}|[a-zA-Z]{4,})',
    searchTerm: '(.*)',
    mfname: '([a-zA-Z]{0,1}[0-9]+[-a-zA-Z0-9]*)',
    street: '(.*)',
    keyWordCatentry: '(.*)',
    categoryUrl: '(.*)',
    langId: '([-]?[0-9]{1,3}|[a-zA-Z]{2}|[a-zA-Z]{2}-[a-zA-Z]{2})',
    seoId: '([0-9]+)',
    productUrl: '(.*)',
    categoryId: '([0-9]+)',
    stlocId: '([0-9]+)',
    mspotname: '(.+)',
    '*': '([-_a-zA-Z0-9]+)',
    pageId: '(.*)'
  };

  public static seoFromApi(apiSeo: ApiSeo): Seo {
    const seo: Seo = {
      pageTemplateRegexMap: this.iSeoTemplateMap,
      paramRegexMap: this.iSeoParamRegexMap,
      paramValuesMap: apiSeo.seoParamMap,
    };
    return seo;
  }

}
